// ============================================================================
//  AdminSection.js — shared page frame used by every Admin Panel sub-view.
//  Keeps the header, action bar, and body layout consistent.
// ============================================================================

import './Admin.css';

export function AdminHeader({ title, description, actions, count }) {
  return (
    <header className="ap-header">
      <div className="ap-header-copy">
        <h1 className="ap-title">
          {title}
          {typeof count === 'number' && <span className="ap-count">{count}</span>}
        </h1>
        {description && <p className="ap-sub">{description}</p>}
      </div>
      {actions && <div className="ap-header-actions">{actions}</div>}
    </header>
  );
}

export function AdminCard({ children, className = '' }) {
  return <section className={`ap-card ${className}`}>{children}</section>;
}

export function AdminEmpty({ title, body, icon, action }) {
  return (
    <div className="ap-empty">
      {icon && <div className="ap-empty-icon">{icon}</div>}
      <h3>{title}</h3>
      {body && <p>{body}</p>}
      {action}
    </div>
  );
}

export function AdminToolbar({ children }) {
  return <div className="ap-toolbar">{children}</div>;
}
